import { render, staticRenderFns } from "./SendEmployeeOtpModal.vue?vue&type=template&id=923c7856&scoped=true"
import script from "./SendEmployeeOtpModal.vue?vue&type=script&lang=js"
export * from "./SendEmployeeOtpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "923c7856",
  null
  
)

export default component.exports